"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _utils = require("../../utils");

var _menu = _interopRequireDefault(require("./menu.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Menu = function Menu(_ref) {
  var filter = _ref.filter,
      partials = _ref.partials,
      sections = _ref.sections,
      _ref$theme$filterColo = _ref.theme.filterColor,
      filterColor = _ref$theme$filterColo === void 0 ? 'red' : _ref$theme$filterColo;
  var MenuLink = partials.MenuLink,
      MenuList = partials.MenuList;
  var filteredSections = filter ? (0, _utils.filterSections)(filterColor, filter, (0, _utils.flattenSections)(sections)) : sections;
  return _react["default"].createElement("div", {
    className: _menu["default"]['menu']
  }, _react["default"].createElement(MenuList, {
    depth: 0,
    partials: partials,
    filteredSections: filteredSections
  }));
};

Menu.propTypes = {
  partials: _propTypes["default"].shape({
    MenuList: _propTypes["default"].func.isRequired
  }).isRequired
};
Menu.defaultProps = {};

var _default = (0, _reactRouterDom.withRouter)(Menu);

exports["default"] = _default;